export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M3.27 6.959a.82.82 0 0 1 1.157.06L12 15.434l7.573-8.415a.82.82 0 0 1 1.217 1.095l-7.844 8.716a1.273 1.273 0 0 1-1.892 0L3.21 8.114a.818.818 0 0 1 .06-1.155Z"/>
</svg>
`;
